<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">巡更记录</div>
      <div class="view-mode-bar" style="padding: 0 0 10px 0;">
        <el-radio-group v-model="viewMode" size="small" @change="onViewModeChange">
          <el-radio-button label="list">列表</el-radio-button>
          <el-radio-button label="stat">统计</el-radio-button>
        </el-radio-group>
      </div>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-row>
          <el-form-item label="巡更员">
            <el-select v-model="personId" placeholder="请选择" clearable>
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="(name, id) in personOptions"
                :key="id"
                :label="name"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡更计划">
            <el-select v-model="planId" placeholder="请选择" clearable>
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="(name, id) in planOptions"
                :key="id"
                :label="name"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡更时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
              :clearable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">重 置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <!-- 列表视图 -->
        <div v-if="viewMode === 'list'" class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="planName"
              label="巡更计划"
            ></el-table-column>
            <el-table-column
              prop="routeName"
              label="巡更路线"
            ></el-table-column>
            <el-table-column
              prop="planBeginTime"
              label="计划开始"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="planEndTime"
              label="计划结束"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="beginTime"
              label="实际开始"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="endTime"
              label="实际结束"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="personName"
              label="巡更员"
              align="center"
            ></el-table-column>
            <el-table-column
              label="巡更结果"
              align="center"
            >
              <template slot-scope="scope">
                <span :style="routeResultStyle(scope.row.routeResult)">{{ scope.row.routeResult }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 统计视图 -->
        <div v-else class="zj-table-container">
          <el-table
            v-loading="statLoading"
            element-loading-text="加载中..."
            :data="statData"
            border
            style="width: 100%"
            show-summary
            :summary-method="statSummary"
            @cell-click="onCellClick"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="routeName"
              label="巡更路线"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="total"
              label="总数"
              width="90"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ontime"
              label="准时/准时率"
              align="center"
              :formatter="formatStat"
              class-name="stat-ontime"
            ></el-table-column>
            <el-table-column
              prop="missed"
              label="漏巡/漏巡率"
              align="center"
              :formatter="formatStat"
              class-name="stat-missed"
            ></el-table-column>
            <el-table-column
              prop="early"
              label="早巡/早巡率"
              align="center"
              :formatter="formatStat"
              class-name="stat-early"
            ></el-table-column>
            <el-table-column
              prop="late"
              label="晚巡/晚巡率"
              align="center"
              :formatter="formatStat"
              class-name="stat-late"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="100"
              align="center"
              :formatter="formatAction"
              class-name="stat-action"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer v-if="viewMode === 'list'">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listPatrolHistory, listAllPatrolHistory, getPersonMap, getPlanMap } from "../../../apis/src/PatrolInspectionApi";
export default {
  name: "PatrolHistoryView",
  controller: "UI",
  action: "patrolHistoryView",
  data() {
    return {
      viewMode: "list",
      searching: false,
      statLoading: false,
      statData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [new Date(), new Date()],
      personId: null,
      planId: null,
      personOptions: {},
      planOptions: {},
      minDate: null,
      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate;
          if (maxDate) {
            this.minDate = null;
          }
        },
        disabledDate: (time) => {
          if (this.minDate) {
            const day = 90 * 24 * 3600 * 1000;
            return (
              time.getTime() < this.minDate.getTime() - day ||
              time.getTime() > this.minDate.getTime() + day
            );
          }
          return false;
        },
      },
    };
  },
  created: function () {
    this.loadOptions();
  },
  mounted: function () {
    this.restoreState();
    if (this.viewMode === "stat") {
      this.loadStat();
    } else {
      this.search();
    }
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    loadOptions() {
      getPersonMap().then((r) => {
        this.personOptions = r.data || {};
      }).catch((e) => {
        console.log(e);
      });
      getPlanMap().then((r) => {
        this.planOptions = r.data || {};
      }).catch((e) => {
        console.log(e);
      });
    },
    getTimeRange() {
      let queryBeginTime = null;
      let queryEndTime = null;
      if (this.date && this.date.length === 2) {
        queryBeginTime = this.date[0].format("yyyy-MM-dd") + " 00:00:00";
        queryEndTime = this.date[1].format("yyyy-MM-dd") + " 23:59:59";
      }
      return { queryBeginTime, queryEndTime };
    },
    search() {
      this.searching = true;
      const { queryBeginTime, queryEndTime } = this.getTimeRange();
      let params = {
        personId: this.personId || undefined,
        planId: this.planId || undefined,
        queryBeginTime: queryBeginTime,
        queryEndTime: queryEndTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      listPatrolHistory(params)
        .then((r) => {
          this.searching = false;
          this.tableData = r.rows || [];
          this.total = r.total || 0;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 统计视图：拉取时间范围内全部记录，前端按巡更路线分组统计
    loadStat() {
      this.statLoading = true;
      const { queryBeginTime, queryEndTime } = this.getTimeRange();
      let params = {
        personId: this.personId || undefined,
        planId: this.planId || undefined,
        queryBeginTime: queryBeginTime,
        queryEndTime: queryEndTime,
      };
      listAllPatrolHistory(params)
        .then(({ rows }) => {
          this.statLoading = false;
          this.statData = this.aggregateByRoute(rows || []);
        })
        .catch((e) => {
          console.log(e);
          this.statLoading = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    aggregateByRoute(rows) {
      // routeResult(中文) -> 英文统计字段，避免模板中中文属性访问
      const resultKeyMap = {
        准时: "ontime",
        漏巡: "missed",
        早巡: "early",
        晚巡: "late",
        补漏巡: "makeup",
      };
      const map = {};
      rows.forEach((r) => {
        // history 记录无 routeId，按 routeName 分组（重名路线会合并）
        const name = r.routeName || "(未命名)";
        if (!map[name]) {
          map[name] = {
            routeName: name,
            total: 0,
            ontime: 0,
            missed: 0,
            early: 0,
            late: 0,
            makeup: 0,
            unknown: 0,
          };
        }
        map[name].total++;
        const k = resultKeyMap[r.routeResult] || "unknown";
        map[name][k]++;
      });
      return Object.values(map);
    },
    rate(count, total) {
      if (!total) return "0.0%";
      return ((count / total) * 100).toFixed(1) + "%";
    },
    // 统计列格式化：数量 / 率（率=该结果数/该路线总数，1 位小数）
    formatStat(row, column) {
      const cnt = row[column.property] || 0;
      return cnt + " / " + this.rate(cnt, row.total);
    },
    // 操作列文字（show-summary 表格 slot-scope 不渲染，改用 formatter + cell-click）
    formatAction() {
      return "查看详情";
    },
    onCellClick(row, column) {
      if (column.label === "操作") {
        this.onRouteDetail(row);
      }
    },
    // 时间必填校验
    checkDate() {
      if (!this.date || this.date.length !== 2 || !this.date[0] || !this.date[1]) {
        this.$message.warning("请选择巡更时间");
        return false;
      }
      return true;
    },
    statSummary({ columns, data }) {
      const sums = [];
      const keyMap = {
        "准时/准时率": "ontime",
        "漏巡/漏巡率": "missed",
        "早巡/早巡率": "early",
        "晚巡/晚巡率": "late",
      };
      columns.forEach((col, idx) => {
        if (idx === 0) {
          sums[idx] = "合计";
          return;
        }
        if (col.label === "巡更路线") {
          sums[idx] = "共 " + data.length + " 条路线";
          return;
        }
        if (col.label === "总数") {
          sums[idx] = data.reduce((s, r) => s + r.total, 0);
          return;
        }
        const key = keyMap[col.label];
        if (key) {
          const cnt = data.reduce((s, r) => s + r[key], 0);
          const tot = data.reduce((s, r) => s + r.total, 0);
          sums[idx] = cnt + " / " + this.rate(cnt, tot);
          return;
        }
        sums[idx] = "";
      });
      return sums;
    },
    onViewModeChange() {
      if (!this.checkDate()) {
        // 时间未选，回退切换
        this.viewMode = this.viewMode === "stat" ? "list" : "stat";
        return;
      }
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    onRouteDetail(row) {
      this.saveState();
      const { queryBeginTime, queryEndTime } = this.getTimeRange();
      this.$router.push({
        path: "/plugin/patrolInspection/UI/patrolRouteDetailView",
        query: {
          routeName: row.routeName,
          queryBeginTime: queryBeginTime || "",
          queryEndTime: queryEndTime || "",
        },
      });
    },
    // 跳转详情前保存列表页状态，供返回时恢复
    saveState() {
      const s = {
        viewMode: this.viewMode,
        date:
          this.date && this.date.length === 2
            ? [this.date[0].getTime(), this.date[1].getTime()]
            : null,
        personId: this.personId,
        planId: this.planId,
        currentPage: this.currentPage,
      };
      try {
        sessionStorage.setItem("patrolHistoryState", JSON.stringify(s));
      } catch (e) {
        console.log(e);
      }
    },
    restoreState() {
      try {
        const raw = sessionStorage.getItem("patrolHistoryState");
        if (!raw) return;
        const s = JSON.parse(raw);
        this.viewMode = s.viewMode || "list";
        if (s.date && s.date.length === 2) {
          this.date = [new Date(s.date[0]), new Date(s.date[1])];
        }
        this.personId = s.personId || null;
        this.planId = s.planId || null;
        this.currentPage = s.currentPage || 1;
        sessionStorage.removeItem("patrolHistoryState");
      } catch (e) {
        console.log(e);
      }
    },
    onSearch() {
      if (!this.checkDate()) return;
      this.currentPage = 1;
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    onCancel() {
      this.date = [new Date(), new Date()];
      this.personId = null;
      this.planId = null;
      if (this.viewMode === "stat") {
        this.loadStat();
      } else {
        this.search();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data === "") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
    routeResultStyle(result) {
      const colorMap = {
        准时: "#67C23A",
        早巡: "#409EFF",
        晚巡: "#E6A23C",
        补漏巡: "#409EFF",
        漏巡: "#F56C6C",
        未知: "#909399",
      };
      return { color: colorMap[result] || "#909399" };
    },
  },
};
</script>
<style>
.stat-ontime .cell { color: #67C23A; }
.stat-missed .cell { color: #F56C6C; }
.stat-early .cell { color: #409EFF; }
.stat-late .cell { color: #E6A23C; }
.stat-action .cell { color: #409EFF; cursor: pointer; }
.stat-action .cell:hover { text-decoration: underline; }
</style>
